export const SPECS = {
  AddIsPickupFlowToCheckoutUrl: 'specs.stores.AddIsPickupFlowToCheckoutUrl',
  UseSingleCustomerDetailsFormWithComposer: 'specs.stores.UseSingleCustomerDetailsFormWithComposer',
  ShouldForwardContactDetailsPickupFlow: 'specs.stores.ShouldForwardContactDetailsPickupFlow'
};
//# sourceMappingURL=SPECS.js.map